import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { I18nComponent } from './i18n/i18n.component'
import { RouterModule } from '@angular/router'
import { i18nRoutes } from './i18n.routing'
import { SharedModule } from '@shared/shared.module'
import { HttpClientModule } from '@angular/common/http'
import { AvaliableLanguagesComponent } from './avaliable-languages/avaliable-languages.component'
import { SelectLanguageComponent } from './select-language/select-language.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { TranslationsListComponent } from './i18n/translations-list/translations-list.component'
import { TranslationCrudComponent } from './i18n/translation-crud/translation-crud.component'
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { ContentEditableModule } from './content-editable/content-editable.module'
import { MatDialogModule } from '@angular/material/dialog'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    I18nComponent,
    AvaliableLanguagesComponent,
    SelectLanguageComponent,
    TranslationsListComponent,
    TranslationCrudComponent,
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    SweetAlert2Module,
    ContentEditableModule,
    MatDialogModule,
    RouterModule.forRoot(i18nRoutes, { scrollPositionRestoration: 'top' }),
    BreadcrumbsModule,
  ],
  exports: [SelectLanguageComponent],
})
export class I18nModule {}
